/**
 * Scoring Explanation API Client
 */

import { edgeGet } from '../edgeInvoke';

// Type definition for scoring explanation (matches backend)
export interface SnapshotScoringExplanation {
  final_score: number;
  tier_label: 'needs_focus' | 'developing' | 'strong' | 'champion';
  skill_level: 'beginner' | 'intermediate' | 'advanced' | 'low_handicap' | 'scratch_plus';
  peer_label: 'weak_for_level' | 'solid_for_level' | 'strong_for_level' | 'elite_for_level';
  peer_thresholds: { weak: number; solid: number; strong: number; elite: number };
  top_3_faults: Array<{
    taxonomy_key: string;
    median_severity: 0 | 1 | 2 | 3;
    avg_confidence: number;
    base_penalty: number;
    confidence_multiplier: number;
    fault_penalty: number;
    consistency: number;
  }>;
  occasional_faults: Array<{
    taxonomy_key: string;
    consistency: number;
    reason: string;
  }>;
  compounding_multiplier: number;
  base_total_penalty: number;
  total_penalty: number;
  calculation_steps: string[];
  strengths?: string[];
  faq?: Array<{ question: string; answer: string }>;
}

/**
 * Get snapshot scoring explanation
 */
export async function getSnapshotExplanation(snapshotId: string): Promise<SnapshotScoringExplanation> {
  const path = `scoring-explanation/snapshot/${snapshotId}`;
  return edgeGet<SnapshotScoringExplanation>(path);
}

/**
 * Get swing scoring explanation
 */
export async function getSwingExplanation(runId: string): Promise<SnapshotScoringExplanation> {
  const path = `scoring-explanation/swing/${runId}`;
  return edgeGet<SnapshotScoringExplanation>(path);
}

